import {
  DiversityFormActions,
  PROCEED_TO_NEXT_FORM_STEP,
  GO_BACK,
  SET_DIVERSITY_FORM_LOADING,
  SET_PAGE_TRANSITION_DIRECTION,
  SUBMIT_DIVERSITY_FORM,
  SUBMIT_DIVERSITY_FORM_ERROR,
} from "../actionTypes/diversityForm";

export interface DiversityFormState {
  step: number;
  formLoading: boolean;
  serverError: boolean;
  pageTransitionDirection: string;
}

const initialState: DiversityFormState = {
  step: 1,
  formLoading: false,
  serverError: false,
  pageTransitionDirection: "forwards",
};

const diversityFormReducer = (
  state = initialState,
  action: DiversityFormActions
): DiversityFormState => {
  switch (action.type) {
    case PROCEED_TO_NEXT_FORM_STEP:
      return {
        ...state,
        step: state.step + 1,
      };
    case GO_BACK:
      return {
        ...state,
        step: state.step - 1,
      };
    case SET_DIVERSITY_FORM_LOADING:
      return {
        ...state,
        formLoading: true,
      };
    case SET_PAGE_TRANSITION_DIRECTION:
      return {
        ...state,
        pageTransitionDirection: action.payload.direction,
      };
    case SUBMIT_DIVERSITY_FORM:
      return {
        ...state,
        serverError: false,
        formLoading: false,
        step: state.step + 1,
      };
    case SUBMIT_DIVERSITY_FORM_ERROR:
      return {
        ...state,
        formLoading: false,
        serverError: true,
      };
    default:
      return state;
  }
};

export default diversityFormReducer;
